export default __webpack_public_path__ + "static/media/schedule_icon_white.52473e27.svg";